var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.440918,
    y: 0.979065,
    width: 12,
    height: 12,
    fill: "url(#pattern0_15026_5257)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_15026_5257",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_15026_5257",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_15026_5257",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA1klEQVR4nO2XPQoCMRCFcwQ9wd7D2sLa1oMsgoWdVpYieAArwcrcQay0EwtPIHqCT0YWlTDJsqKrxTx4zeRN8mAmf84554A59WMma98B+GCwB7QDSiyGvqIXDhM5PmUgeww+NVlisk6oL3K6ZgArwZtNeAHOAfdAM8KVohcuIvppmQENJ63TS/KXEf3EDGAlIN2EIyAPKOf9OMKBos+LuKbf2F2A3Yb8+XtgB2wDSiyGg6IXHhM566rb8NNsVSrBV4EZwEqANaG3bciPD6LX7/kVaNS1+A1M9fiFsVOcnwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStarted);
export default __webpack_public_path__ + "static/media/Get_started.5c9687ac1629d299dde6c4bfc593e896.svg";
export { ForwardRef as ReactComponent };